<script>
import NewForm from './New'
/* eslint-disable no-console */
export default {
  mixins: [NewForm],
  data() {
    return {
      root: 'patterns'
    }
  },
  methods: {
    load() {
      this.$http.get(`${this.root}/${this.$route.query.id}`).then(res => {
        this.form = res.data
        this.departurePlace =
          this.form.departurePortCode !== null
            ? this.places.find(
                p =>
                  p.value === this.form.departurePortCode && p.type === 'port'
              )
            : this.places.find(
                p =>
                  p.value === this.form.departureWarehouseId &&
                  p.type === 'warehouse'
              )
      })
    },
    save() {
      this.$http
        .put(`${this.root}/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1)
        })
    },
    remove() {
      this.$http.delete(`${this.root}/${this.$route.query.id}`).then(() => {
        this.$router.go(-1)
      })
    }
  },
  mounted() {
    this.load()
  }
}
</script>
